export default "__VITE_ASSET__xd7buYDO__"